<template>
  <nav
    class="navbar-expand-lg absolute z-50 flex w-full flex-wrap items-center justify-between py-3"
  >
    <div
      class="container z-10 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="relative flex w-full justify-between px-6 sm:static sm:block sm:w-auto sm:justify-start"
      >
        <a
          class="
            group
            mr-4
            inline-flex
            whitespace-nowrap
            py-2
            text-lg
            font-semibold
            leading-relaxed
            text-slate-100
            transition-all
            hover:text-white
          "
          href="/"
          style="font-family: 'Montserrat Alternates', sans-serif;"
        >
          <span class="w-0 transition-all duration-300 ease-in-out group-hover:w-[5px]">&nbsp;</span>
          {{ appName.p1 }}
          <span class="w-[5px] transition-all duration-300 ease-in-out group-hover:w-0">&nbsp;</span>
          {{ appName.p2 }}
          <span class="opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100">
            {{ appName.p3 }}
          </span>
        </a>
        <button
          class="
            block
            rounded-lg
            border
            border-solid
            border-transparent
            bg-transparent
            px-3
            py-1
            text-xl
            leading-none
            text-slate-100
            outline-hidden
            hover:text-white
            focus:outline-hidden
            sm:hidden
          "
          type="button"
          aria-label="Menu"
          @click="setNavbarOpen"
        >
          <i class="fa-solid fa-bars" />
        </button>
      </div>
      <div
        class="grow items-center sm:flex"
        :class="[navbarOpen ? 'block bg-[rgba(0,0,0,0.75)] p-4 sm:bg-inherit' : 'hidden']"
      >
        <ul class="m-0 flex list-none flex-col sm:ml-auto sm:flex-row">
          <li class="flex items-center">
            <a
              class="flex items-center px-3 py-2 text-xs font-bold uppercase text-slate-100 hover:text-white"
              href="/#features"
            >
              <span class="ml-2 inline-block">Features</span>
            </a>
          </li>
          <li class="flex items-center">
            <a
              class="flex items-center px-3 py-2 text-xs font-bold uppercase text-slate-100 hover:text-white"
              href="/pricing"
            >
              <span class="ml-2 inline-block">Pricing</span>
            </a>
          </li>

          <li class="flex items-center">
            <a
              class="flex items-center px-3 py-2 text-xs font-bold uppercase text-slate-100 hover:text-white"
              href="https://support.rackmanage.io/"
            >
              <span class="ml-2 inline-block">Help</span>
            </a>
          </li>

          <li
            v-if="user"
            class="flex items-center"
          >
            <router-link to="/app/dashboard">
              <button
                class="
                  mb-3
                  ml-3
                  mt-2
                  rounded-lg
                  bg-slate-100
                  px-4
                  py-2
                  text-xs
                  font-bold
                  uppercase
                  text-black
                  shadow
                  outline-hidden
                  transition-all
                  duration-150
                  ease-linear
                  hover:bg-white
                  hover:shadow-lg
                  focus:outline-hidden
                  active:bg-white
                  sm:my-0
                  sm:mr-1
                "
                type="button"
              >
                Dashboard
              </button>
            </router-link>
          </li>
          <li
            v-else
            class="flex items-center"
          >
            <router-link to="/auth/login">
              <button
                class="
                  mb-3
                  ml-3
                  mt-2
                  rounded-lg
                  bg-slate-100
                  px-4
                  py-2
                  text-xs
                  font-bold
                  uppercase
                  text-black
                  shadow
                  outline-hidden
                  transition-all
                  duration-150
                  ease-linear
                  hover:bg-white
                  hover:shadow-lg
                  focus:outline-hidden
                  active:bg-white
                  sm:my-0
                  sm:mr-1
                "
                type="button"
              >
                Login / Sign Up
              </button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useStore } from '../../api/index.ts';

const store = useStore();
const navbarOpen = ref(false);
const appName = {
  p1: import.meta.env.VITE_APP_NAME_P1,
  p2: import.meta.env.VITE_APP_NAME_P2,
  p2extra: import.meta.env.VITE_APP_NAME_P2_EXTRA,
  p3: import.meta.env.VITE_APP_NAME_P3,
};
const user = computed(() => store.user);

function setNavbarOpen() {
  navbarOpen.value = !navbarOpen.value;
}
</script>
